import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Son difíciles de conseguir los ingredientes?',
    a: 'No, usamos ingredientes clave como sal de mar, avena, aceites de cocina prensados en frío y botánicos comunes.'
  }, {
    q: '¿Cuánto tiempo toma cada receta?',
    a: 'La preparación toma menos de 5 minutos; el ritual de uso es de unos 15.'
  }, {
    q: '¿Es apto para piel con acné?',
    a: 'Sí, incluimos una receta específica de limpieza profunda y detox ideal para purificar poros obstruidos.'
  }, {
    q: '¿Recibo un producto físico?',
    a: 'No, es una guía digital de acceso inmediato para que empieces hoy mismo.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-botanical-ivory-dark" data-id="element-18">
      <div className="max-w-3xl mx-auto" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-playfair text-botanical-forest mb-4" data-id="element-21">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-22">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white border border-botanical-sage/20 rounded-sm overflow-hidden" data-id="element-23">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full text-left px-6 py-5 flex justify-between items-center focus:outline-none" data-id="element-24">
                <span className="font-playfair text-lg md:text-xl text-botanical-forest pr-4" data-id="element-25">
                  {faq.q}
                </span>
                <ChevronDown className={`text-botanical-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-26" />
              </button>

              <AnimatePresence data-id="element-27">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-28">
                    <div className="px-6 pb-5 text-botanical-forest/70 font-lora" data-id="element-29">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}